/** Design-system button class recipes. Compose with layout/sizing overrides as needed. */
export const PRIMARY_BTN =
  "rounded-md bg-spark-green px-4 py-2 text-sm font-bold text-spark-ink shadow-[0_3px_10px_-2px_rgba(33,214,121,.45)] hover:bg-[#1fc06d] transition-colors disabled:opacity-50";

export const SECONDARY_BTN =
  "rounded-md border border-spark-border bg-white px-3 py-1.5 text-sm font-semibold text-spark-charcoal hover:bg-spark-hover transition-colors disabled:opacity-50";

export const DESTRUCTIVE_BTN =
  "rounded-md border border-[#F3CDD2] bg-white px-4 py-2 text-sm font-semibold text-spark-red-text hover:bg-spark-red-tint/50 transition-colors disabled:opacity-50";

/** PRIMARY_BTN sized for compact toolbars/card headers */
export const PRIMARY_BTN_SM =
  "rounded-md bg-spark-green px-3 py-1.5 text-xs font-bold text-spark-ink shadow-[0_3px_10px_-2px_rgba(33,214,121,.45)] hover:bg-[#1fc06d] transition-colors disabled:opacity-50";

/** Compact secondary button for tight card headers */
export const SECONDARY_BTN_SM =
  "rounded-md border border-spark-border bg-white px-3 py-1.5 text-xs font-semibold text-spark-charcoal hover:bg-spark-hover transition-colors disabled:opacity-50";

/** AI action button: blue fill reserved for Claude-powered actions. White on
 *  #1D5FD6 (the spark-blue-text token) is AA; pair with AIIcon (ui/ai-icon). */
export const AI_BTN =
  "rounded-md bg-spark-blue-text px-4 py-2 text-sm font-bold text-white shadow-[0_3px_10px_-2px_rgba(46,125,247,.45)] hover:bg-[#1750B8] transition-colors disabled:opacity-50";

/** AI_BTN sized for compact toolbars/card headers */
export const AI_BTN_SM =
  "rounded-md bg-spark-blue-text px-3 py-1.5 text-xs font-bold text-white shadow-[0_3px_10px_-2px_rgba(46,125,247,.45)] hover:bg-[#1750B8] transition-colors disabled:opacity-50";

export const LINK_CLASS = "text-spark-blue-text font-semibold hover:underline";

/** Variant → class map shared by SubmitButton and AsyncButton */
export const BUTTON_VARIANT_CLASSES = {
  primary: PRIMARY_BTN,
  secondary: SECONDARY_BTN,
  destructive: DESTRUCTIVE_BTN,
  link: `text-xs ${LINK_CLASS} disabled:text-spark-gray disabled:no-underline focus-visible:ring-2 focus-visible:ring-spark-blue focus-visible:ring-offset-1 focus-visible:outline-none rounded`,
} as const;
